export default __webpack_public_path__ + "static/media/oyo.e86d212e.png";